import { Grid, Box, Typography, Button } from '@mui/material';
import { OverviewStyles, OverviewCard } from '../Info';

const AdvancedMDStatus = props => {
  const { customerData, changeTab } = props;
  const classes = OverviewStyles();

  return (
    <OverviewCard>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Box p={1}>
            <Typography className={classes.headingText} color="primary">
              AdvancedMD
            </Typography>
            <Typography className={classes.bodyText} variant="body2">
              {customerData?.patientLinkedStatus === 'linked'
                ? 'AdvancedMD profile linked'
                : 'No AdvancedMD profile linked'}
            </Typography>
            <Button
              variant="outlined"
              color="primary"
              sx={{ mt: 1 }}
              onClick={() => changeTab('advancedmd')}
            >
              View
            </Button>
          </Box>
        </Grid>
      </Grid>
    </OverviewCard>
  );
};

export default AdvancedMDStatus;
